
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import Switch from '@/components/switch.vue';
	import PageFooter from '@/components/page-footer.vue';
	import {
		getBackendBannerList,
		deleteBanner,
		setBanner
	} from '@/api/material'
	import Message from '@/components/message.vue'
	import {imgHost} from '@/utils/config'

	@Component({
		name: 'operation-banner',
		components: {
			PageFooter,
			'slz-switch': Switch,
			Message
		}
	})
	export default class OperationBanner extends Vue {
		private imgUrl = imgHost;
		private keyword = '';
		private isOpen = false;
		private pageNo = 1;
		private pageSize = 12;
		private list: any = [];
		private total = 0;
		private bannerIdKey = '';
		private showDialog = false;
		private currentId = 0;
		private bannerTypes = ['未关联', '商品关联', '文章关联']

		private mounted() {
			this.getList();
		}

		// 清空搜索
		private clearSearch() {
			this.pageNo = 1;
			this.bannerIdKey = '';
			this.getList();
		}

		private doSearch(){
			this.pageNo = 1;
			this.getList();
		}

		// 跳转到详情页面
		private toDetail(type: string, id ? : number) {
			this.$router.push({
				name: 'Banner_Detail',
				query: {
					type,
					id: id + ''
				}
			})
		}

		// 修改页面
		private changePage(e) {
			this.pageNo = e;
			this.getList();
		}

		// 删除轮播图
		private showDeleteDialog(id: number) {
			this.showDialog = true;
			this.currentId = id;
		}

		// 获取轮播图列表
		private async getList() {
			try {
				const res: any = await getBackendBannerList({
					Skip: (this.pageNo - 1) * this.pageSize,
					Take: this.pageSize,
					Id: +this.bannerIdKey || ''
				})
				this.list = res.Result.Results || [];
				this.total = res.Result.Total;
			} catch (e) {
				console.log('getBackendBannerList ===>', e)
			}
		}

		// 确认删除
		private async confirmDelete() {
			try {
				await deleteBanner({
					Id: this.currentId
				})
				this.pageNo = 1
				this.getList();
				this.$message({
					type: 'success',
					message: '删除成功'
				})
			} catch (e) {
				console.log('deleteBanner ===>', e)
			}
		}

		// 设置状态
		private async handleShow(e: boolean, row: any) {
			try {
				await setBanner({Id: row.Id})
				this.$message({
					type: 'success',
					message: '更新成功！'
				})
			} catch (e) {
				console.log('setBanner ===>', e)
			}
		}
	}
